import styled from 'styled-components';

export const LoadingStyled = styled.div`
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  height: 96px;
  margin-top: -48px;
  margin-left: -48px;
`;

export const RelativeLoadingStyled = styled.div`
  text-align: center;
`;

export const LoadingStringStyled = styled.div`
  font-weight: bold;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: 70px;
  margin-left: -64px;
  color: var(--ds-text, var(--ds-fb-text));
`;

export const RelativeLoadingStringStyled = styled.div`
  font-weight: bold;
  text-align: center;
  margin-top: 22px;
  color: var(--ds-text, var(--ds-fb-text));
`;
